/**
 * Stack — vertical flex layout with consistent gap.
 * UI stability primitive: gap var(--space-4).
 */
import React from 'react';

export default function Stack({ children, gap = 'var(--space-4)', className = '', style = {}, ...rest }) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
